import './form.scss'

/* React */
import { useState } from 'react'

/* Bootstrap */
import Form from 'react-bootstrap/Form'
import InputGroup from 'react-bootstrap/InputGroup'
import React from 'react'

/* Types */
import { input } from './Form'

/* FontAwesome */
import { FontAwesomeIcon as FontAwesome } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

export interface inputProps extends input {
  name: string
  defaultValue: string
  onChange: (name:string, value:string) => void
}

const Input: React.FC<inputProps> = ({
  name,
  type = 'text',
  autoComplete = 'off',
  required,

  preAddon,
  sufAddon,
  hilfe,

  defaultValue,
  onChange,

  ...rest
}) => {

  const [showHilfe, setShowHilfe] = useState(false)

  return <>
    <InputGroup>
    
      { preAddon && 
        <InputGroup.Text className='preAddon'>
          {preAddon}
        </InputGroup.Text>
      }
  
      <Form.Control {...{
        name,
        type,
        autoComplete,
        onChange:(e=>onChange(name, e.target.value)),
        defaultValue,
        required,
        ...rest
      }} />

      { sufAddon && 
        <InputGroup.Text>
          {sufAddon}
        </InputGroup.Text>
      }
      
      { hilfe && 
        <InputGroup.Text>
          <button
            style={{border: 'none', background: 'none'}}
            onClick={e=>{
              e.preventDefault()
              setShowHilfe(!showHilfe)
            }}
          >
            <FontAwesome icon={faQuestionCircle} />
          </button>
        </InputGroup.Text>
      }

    </InputGroup>

    { showHilfe && hilfe &&
      <div className='Component-Form-Hilfe'>
        {hilfe}
      </div>
    }

  </>
}

export default Input